export default "__VITE_ASSET__f3dbc100__"